export const esDashboard = {
  'dashboard.activity': 'Actividad',
  'dashboard.activeMovement': 'Movimiento activo en la proyección',
  'dashboard.addNote': 'Agregar nota…',
  'dashboard.addMovement': 'Agregar movimiento',
  'dashboard.agendaClear': 'Tu agenda está libre',
  'dashboard.agendaTitle': 'Confirma lo que realmente pasó.',
  'dashboard.amount': 'Monto',
  'dashboard.balance': 'Saldo',
  'dashboard.balancePlanned': 'Balance planificado',
  'dashboard.calendarDescription': 'Explora cada ocurrencia y su efecto en tu saldo proyectado.',
  'dashboard.calendarTitle': 'Mira tu mes antes de vivirlo.',
  'dashboard.category': 'Categoría',
  'dashboard.chartData': 'Ver datos del gráfico',
  'dashboard.chartLabel': 'Proyección de saldo desde {start} hasta {end}',
  'dashboard.chartSample': 'Muestra semanal de la proyección',
  'dashboard.chooseFutureDate': 'Elegir horizonte futuro',
  'dashboard.closeTarget': 'Meta cubierta',
  'dashboard.covered': 'Tu cierre de mes ya está cubierto.',
  'dashboard.dailyAgenda': 'Agenda del día',
  'dashboard.dailyGoal': 'Meta de ingreso de hoy',
  'dashboard.date': 'Fecha',
  'dashboard.dateLimit': 'Fecha límite',
  'dashboard.destinationWallet': 'Wallet destino',
  'dashboard.deleteMovement': 'Eliminar movimiento',
  'dashboard.deleteMovementWarning':
    'Este movimiento desaparecerá de toda la proyección futura. Confirma para eliminarlo.',
  'dashboard.confirmDeleteMovement': 'Sí, eliminar',
  'dashboard.editMovement': 'Editar movimiento',
  'dashboard.editNote': 'Editar nota',
  'dashboard.endMonth': 'Fin de mes',
  'dashboard.endMonthEstimate': 'Saldo estimado al cierre del mes',
  'dashboard.exploreFuture': 'Explorar mi futuro',
  'dashboard.expense': 'Gasto',
  'dashboard.expenses': 'Gastos',
  'dashboard.filterAll': 'Todos',
  'dashboard.filterMovements': 'Filtrar movimientos',
  'dashboard.filterOneTime': 'Una vez',
  'dashboard.filterRecurring': 'Recurrentes',
  'dashboard.filterTransfers': 'Transferencias',
  'dashboard.frequency': 'Frecuencia',
  'dashboard.frequencyBiweekly': 'Quincenal',
  'dashboard.frequencyMonthly': 'Mensual',
  'dashboard.frequencyOneTime': 'Una vez',
  'dashboard.frequencyWeekly': 'Semanal',
  'dashboard.income': 'Ingreso',
  'dashboard.incomes': 'Ingresos',
  'dashboard.inSixMonths': '6 meses',
  'dashboard.inThreeMonths': '3 meses',
  'dashboard.ifNothingChanges': 'Si nada cambia',
  'dashboard.loadingFinancial': 'Estamos preparando tu información financiera.',
  'dashboard.lowPoint': 'Punto más bajo',
  'dashboard.missingData': 'Necesitas al menos una wallet y una categoría compatible.',
  'dashboard.monthDescription': 'Organiza ingresos, gastos y transferencias desde un solo lugar.',
  'dashboard.monthTitle': 'Este mes, bajo control.',
  'dashboard.movements': 'Movimientos',
  'dashboard.myPlan': 'Mi plan',
  'dashboard.nextMovement': 'Próximo movimiento',
  'dashboard.noDayMovements': 'No hay movimientos previstos para este día.',
  'dashboard.noMovements': 'No hay movimientos en esta vista',
  'dashboard.noMovementsDescription': 'Prueba otro filtro o agrega tu próximo movimiento.',
  'dashboard.noProjection': 'Agrega un movimiento para comenzar a proyectar.',
  'dashboard.note': 'Nota',
  'dashboard.noteError': 'No pudimos guardar la nota. Inténtalo de nuevo.',
  'dashboard.oneMonth': '1 mes',
  'dashboard.optional': '(opcional)',
  'dashboard.previousMonth': 'Mes anterior',
  'dashboard.nextMonth': 'Mes siguiente',
  'dashboard.projectedExpense': 'Gasto previsto',
  'dashboard.projectedIncome': 'Ingreso previsto',
  'dashboard.quickTitle': 'Registra un gasto en segundos.',
  'dashboard.projectedBy': 'Saldo proyectado al {date}',
  'dashboard.projectionCritical': 'Crítico',
  'dashboard.projectionRisk': 'En riesgo',
  'dashboard.projectionStable': 'Estable',
  'dashboard.projectionToday': 'Proyección de hoy',
  'dashboard.recoveryNeeded': 'Recuperación necesaria',
  'dashboard.recurring': 'Recurrentes',
  'dashboard.remainingGoal': '{days} días para cubrir {amount}.',
  'dashboard.saveError': 'No pudimos guardar el movimiento. Revisa los datos e inténtalo de nuevo.',
  'dashboard.saveMovement': 'Guardar movimiento',
  'dashboard.selectDestination': 'Selecciona destino',
  'dashboard.statusUpdating': 'Actualizando…',
  'dashboard.staleData':
    'Mostrando la última información guardada. Intentaremos actualizarla al recuperar conexión.',
  'dashboard.today': 'Hoy',
  'dashboard.toolsTitle': 'Tu futuro, mes a mes.',
  'dashboard.transfer': 'Transferencia',
  'dashboard.transferBetweenWallets': 'Transferencia entre wallets',
  'dashboard.trialExpired': 'Tu prueba de 7 días terminó',
  'dashboard.trialExpiredDescription':
    'Elige un plan para recuperar tus proyecciones, movimientos y wallets.',
  'dashboard.type': 'Tipo',
  'dashboard.unavailable': 'no disponible',
  'dashboard.unknownCategory': 'Sin categoría',
  'dashboard.viewDescription': 'Anticipa lo que viene y toma decisiones con tiempo.',
  'dashboard.viewEyebrow': 'Tu panorama financiero',
  'dashboard.viewPlanDetails': 'Ver detalles en Plan',
  'dashboard.viewTitle': 'Tu dinero, con perspectiva.',
  'dashboard.futureEyebrow': 'Próximos meses',
  'dashboard.futureTitle': 'Así se ve tu futuro',
  'dashboard.weekdayFriday': 'V',
  'dashboard.weekdayMonday': 'L',
  'dashboard.weekdaySaturday': 'S',
  'dashboard.weekdaySunday': 'D',
  'dashboard.weekdayThursday': 'J',
  'dashboard.weekdayTuesday': 'M',
  'dashboard.weekdayWednesday': 'X',
  'dashboard.loadError': 'No pudimos cargar tus finanzas',
  'dashboard.loadErrorDescription':
    'Comprueba tu conexión o vuelve a iniciar sesión y prueba nuevamente.',
  'dashboard.calendarDayLabel': '{date}, {count} movimientos, saldo {balance}',
} as const;

export const enDashboard: Record<keyof typeof esDashboard, string> = {
  'dashboard.activity': 'Activity',
  'dashboard.activeMovement': 'Movement active in the projection',
  'dashboard.addNote': 'Add note…',
  'dashboard.addMovement': 'Add movement',
  'dashboard.agendaClear': 'Your schedule is clear',
  'dashboard.agendaTitle': 'Confirm what actually happened.',
  'dashboard.amount': 'Amount',
  'dashboard.balance': 'Balance',
  'dashboard.balancePlanned': 'Planned balance',
  'dashboard.calendarDescription':
    'Explore every occurrence and its impact on your projected balance.',
  'dashboard.calendarTitle': 'See your month before it happens.',
  'dashboard.category': 'Category',
  'dashboard.chartData': 'View chart data',
  'dashboard.chartLabel': 'Balance projection from {start} to {end}',
  'dashboard.chartSample': 'Weekly projection sample',
  'dashboard.chooseFutureDate': 'Choose a future horizon',
  'dashboard.closeTarget': 'Goal covered',
  'dashboard.covered': 'Your month-end balance is already covered.',
  'dashboard.dailyAgenda': 'Daily agenda',
  'dashboard.dailyGoal': "Today's income goal",
  'dashboard.date': 'Date',
  'dashboard.dateLimit': 'End date',
  'dashboard.destinationWallet': 'Destination wallet',
  'dashboard.deleteMovement': 'Delete movement',
  'dashboard.deleteMovementWarning':
    'This movement will disappear from the entire future projection. Confirm to delete it.',
  'dashboard.confirmDeleteMovement': 'Yes, delete',
  'dashboard.editMovement': 'Edit movement',
  'dashboard.editNote': 'Edit note',
  'dashboard.endMonth': 'End of month',
  'dashboard.endMonthEstimate': 'Estimated balance at the end of the month',
  'dashboard.exploreFuture': 'Explore my future',
  'dashboard.expense': 'Expense',
  'dashboard.expenses': 'Expenses',
  'dashboard.filterAll': 'All',
  'dashboard.filterMovements': 'Filter movements',
  'dashboard.filterOneTime': 'One time',
  'dashboard.filterRecurring': 'Recurring',
  'dashboard.filterTransfers': 'Transfers',
  'dashboard.frequency': 'Frequency',
  'dashboard.frequencyBiweekly': 'Biweekly',
  'dashboard.frequencyMonthly': 'Monthly',
  'dashboard.frequencyOneTime': 'One time',
  'dashboard.frequencyWeekly': 'Weekly',
  'dashboard.income': 'Income',
  'dashboard.incomes': 'Income',
  'dashboard.inSixMonths': '6 months',
  'dashboard.inThreeMonths': '3 months',
  'dashboard.ifNothingChanges': 'If nothing changes',
  'dashboard.loadingFinancial': 'We are preparing your financial information.',
  'dashboard.lowPoint': 'Lowest point',
  'dashboard.missingData': 'You need at least one wallet and one compatible category.',
  'dashboard.monthDescription': 'Organize income, expenses, and transfers in one place.',
  'dashboard.monthTitle': 'This month, under control.',
  'dashboard.movements': 'Movements',
  'dashboard.myPlan': 'My plan',
  'dashboard.nextMovement': 'Next movement',
  'dashboard.noDayMovements': 'There are no planned movements for this day.',
  'dashboard.noMovements': 'There are no movements in this view',
  'dashboard.noMovementsDescription': 'Try another filter or add your next movement.',
  'dashboard.noProjection': 'Add a movement to start projecting.',
  'dashboard.note': 'Note',
  'dashboard.noteError': 'We could not save the note. Try again.',
  'dashboard.oneMonth': '1 month',
  'dashboard.optional': '(optional)',
  'dashboard.previousMonth': 'Previous month',
  'dashboard.nextMonth': 'Next month',
  'dashboard.projectedExpense': 'Planned expense',
  'dashboard.projectedIncome': 'Planned income',
  'dashboard.quickTitle': 'Record an expense in seconds.',
  'dashboard.projectedBy': 'Projected balance by {date}',
  'dashboard.projectionCritical': 'Critical',
  'dashboard.projectionRisk': 'At risk',
  'dashboard.projectionStable': 'Stable',
  'dashboard.projectionToday': "Today's projection",
  'dashboard.recoveryNeeded': 'Recovery needed',
  'dashboard.recurring': 'Recurring',
  'dashboard.remainingGoal': '{days} days to cover {amount}.',
  'dashboard.saveError': 'We could not save the movement. Review the data and try again.',
  'dashboard.saveMovement': 'Save movement',
  'dashboard.selectDestination': 'Select destination',
  'dashboard.statusUpdating': 'Updating…',
  'dashboard.staleData':
    'Showing the latest saved information. We will refresh it when the connection returns.',
  'dashboard.today': 'Today',
  'dashboard.toolsTitle': 'Your future, month by month.',
  'dashboard.transfer': 'Transfer',
  'dashboard.transferBetweenWallets': 'Transfer between wallets',
  'dashboard.trialExpired': 'Your 7-day trial has ended',
  'dashboard.trialExpiredDescription':
    'Choose a plan to recover your projections, movements, and wallets.',
  'dashboard.type': 'Type',
  'dashboard.unavailable': 'unavailable',
  'dashboard.unknownCategory': 'Uncategorized',
  'dashboard.viewDescription': 'See what is coming and make decisions ahead of time.',
  'dashboard.viewEyebrow': 'Your financial outlook',
  'dashboard.viewPlanDetails': 'View details in Plan',
  'dashboard.viewTitle': 'Your money, in perspective.',
  'dashboard.futureEyebrow': 'Coming months',
  'dashboard.futureTitle': 'Your financial future',
  'dashboard.weekdayFriday': 'F',
  'dashboard.weekdayMonday': 'M',
  'dashboard.weekdaySaturday': 'S',
  'dashboard.weekdaySunday': 'S',
  'dashboard.weekdayThursday': 'T',
  'dashboard.weekdayTuesday': 'T',
  'dashboard.weekdayWednesday': 'W',
  'dashboard.loadError': 'We could not load your finances',
  'dashboard.loadErrorDescription': 'Check your connection or sign in again and try once more.',
  'dashboard.calendarDayLabel': '{date}, {count} movements, balance {balance}',
};
